import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Typography, Button, CircularProgress, Box, Modal } from '@mui/material';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded';

import ModalCard from '../../layout/modal-card';

const PREFIX = 'FileUploadPresentation';

const classes = {
  image: `${PREFIX}-image`,
  formImage: `${PREFIX}-formImage`,
  noDisplay: `${PREFIX}-noDisplay`,
  changeFileButton: `${PREFIX}-changeFileButton`,
  buttonIcon: `${PREFIX}-buttonIcon`,
  successIcon: `${PREFIX}-successIcon`,
  smallImage: `${PREFIX}-smallImage`,
  circularProgress: `${PREFIX}-circularProgress`,
};

const StyledBox = styled(Box)(() => ({
  borderColor: '#E6E6E6',
  marginBottom: 20,
  borderRadius: 8,

  [`& .${classes.image}`]: {
    width: 300,
    height: 150,
    '@media (max-width: 500px)': {
      maxWidth: '200px',
    },
  },

  [`& .${classes.formImage}`]: {
    width: 300,
    '@media (max-width: 500px)': {
      maxWidth: '200px',
    },
  },

  [`& .${classes.noDisplay}`]: {
    display: 'none',
  },

  [`& .${classes.changeFileButton}`]: {
    marginTop: 20,
  },

  [`& .${classes.buttonIcon}`]: {
    margin: '0px 0px 2px 5px',
  },

  [`& .${classes.successIcon}`]: {
    color: '#fff',
    backgroundColor: '#2AAFBB',
    borderRadius: '10px',
    padding: 5,
    margin: 10,
  },

  [`& .${classes.smallImage}`]: {
    marginBottom: 15,
    maxWidth: '400px',
  },

  [`& .${classes.circularProgress}`]: {
    margin: '0px auto',
    display: 'block',
  },
}));

const FileUploadPresentation = (props) => {
  const {
    currentFormObject,
    handleModalClose,
    modalOpen,
    handleChange,
    url,
    progress,
    loading,
    formContext,
    uploadedFileName,
  } = props;
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <StyledBox>
      {url && !loading && (
        <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
          {currentFormObject.fileType === 'image/*' && (
            <img src={url} alt="identification" className={formContext ? classes.formImage : classes.image} />
          )}
          {currentFormObject.fileType !== 'image/*' && (
            <>
              {!imgLoaded && <PlaylistAddCheckRoundedIcon className={classes.successIcon} fontSize="large" />}
              <img
                style={imgLoaded ? {} : { display: 'none' }}
                src={url}
                onLoad={() => setImgLoaded(true)}
                onError={() => setImgLoaded(false)}
                className={classes.smallImage}
                alt="Capsule Products"
              />
              <br />
              <Typography variant="body1" align="center">
                {uploadedFileName || 'File Uploaded'}
              </Typography>
            </>
          )}
          <br />
          <label htmlFor={currentFormObject.reference}>
            <input
              onChange={handleChange}
              accept={currentFormObject.fileType}
              className={classes.noDisplay}
              id={currentFormObject.reference}
              multiple
              type="file"
            />
            <Button className={classes.changeFileButton} variant="outlined" component="span" color="primary">
              Change file
            </Button>
          </label>
        </Grid>
      )}
      <CircularProgress
        variant="determinate"
        value={progress}
        className={loading ? classes.circularProgress : classes.noDisplay}
      />
      {!url && !loading && (
        <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
          <br />
          <label htmlFor={currentFormObject.reference}>
            <input
              onChange={handleChange}
              accept={currentFormObject.fileType}
              className={classes.noDisplay}
              id={currentFormObject.reference}
              multiple
              type="file"
            />
            <Button
              size="large"
              startIcon={<FileUploadRoundedIcon className={classes.buttonIcon} color="primary" fontSize="large" />}
              variant="outlined"
              component="span"
              color="primary"
            >
              {currentFormObject.buttonText}
            </Button>
          </label>
        </Grid>
      )}
      <Modal open={modalOpen}>
        <>
          <ModalCard
            text="Upload error occurred"
            subtext="Please contact support@candor.org"
            handleModalClose={handleModalClose}
            loadingComponent={false}
          />
        </>
      </Modal>
    </StyledBox>
  );
};

export default FileUploadPresentation;
